import React from 'react';
import styles from '../Toolbar.module.scss';
import Button from '@srcDS/js/components/atoms/button';
import { useFilter } from '@srcDS/js/tastic/pages/category/hooks/useFilter';
import { renderActiveFilterTerms } from '../utils/renderActiveFilterTerms';

const FilterModalContent = ({ activeFilter, closeModal }) => {
  const { handleFacetChange, localFilters, handleSubmitFaceChange, setFilterDisplayValues, onPriceRangeChange, isAnySelected,  } =
    useFilter();

  return (
    <>
      {renderActiveFilterTerms({
        localFilters,
        activeFilter,
        handleFacetChange,
        onPriceRangeChange,
        isMobile: false,
      })}
      {/* @ts-ignore */}
      <Button
        variant="primary"
        customClasses={{
          button: styles.applyButton,
        }}
        disabled={!isAnySelected && activeFilter.type !== 'range'}
        onClick={(event) => {
          handleSubmitFaceChange({
            callback: () => {
              setFilterDisplayValues((values) => ({
                ...values,
                filterShown: false,
              }));
              closeModal(event);
            },
          });
        }}
      >
        Apply Filters
      </Button>
    </>
  );
};

export default FilterModalContent;
